import angular from 'angular';
import template from './template.html';
import './style.scss';

export class EmailTile {
    removeClick() {
        this.onRemoveClick({email: this.email});
    }
}

export const EmailTileConfiguration = {
    template,
    bindings: {
        email: '<',
        onRemoveClick: '&',
    },
    controller: EmailTile,
    controllerAs: 'emailTileCtrl'
};

angular.module('TALENYA-FE').component('emailTile', EmailTileConfiguration);
